import React, { createContext, useEffect, useState } from 'react'
import { getSolicitations } from '../services/solicitations'
import { getNotificationByProfessionalId } from '../services/notifications'

export const RootContext = createContext([false, () => {}])

export const RootProvider = ({ children }) => {
  const userData = JSON.parse(localStorage.getItem('userData'))
  const [state, setState] = useState({
    userData,
    solicitationsList: [],
    notificationsList: []
  })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const { professional } = JSON.parse(localStorage.getItem('userData')) || {}

    if (professional && !state.solicitationsList.length && !state.notificationsList.length) {
      handleGetSolicitations(professional.id)
      handleGetNotifications(professional.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem('userData')])

  const handleGetSolicitations = async (professionalId) => {
    setLoading(true)
    const solicitations = await getSolicitations(professionalId)
    setState(prevState => ({
      ...prevState,
      solicitationsList: solicitations || []
    }))
    setLoading(false)
  }

  const handleGetNotifications = async (professionalId) => {
    setLoading(true)
    const payload = {
      id: professionalId,
      skip: 0,
      limit: null
    }
    const notifications = await getNotificationByProfessionalId(payload)
    setState(prevState => ({
      ...prevState,
      notificationsList: notifications.list || []
    }))
    setLoading(false)
  }

  const handleUpdateSolicitation = (oldSolicitation, newSolicitation) => {
    const newSolicitationList = state.solicitationsList.filter(solicitation => solicitation.id !== oldSolicitation)
    setState({
      ...state,
      solicitationsList: [...newSolicitationList, newSolicitation]
    })
  }

  const handleUpdateNotifications = (oldNotification, newNotification) => {
    const newNotificationList = state.notificationsList.filter(notification => notification.id !== oldNotification)
    setState({
      ...state,
      notificationsList: [...newNotificationList, newNotification]
    })
  }

  const handleUpdateUserData = (userData) => {
    setState({
      ...state,
      userData
    })
  }

  return (
    <RootContext.Provider value={{ globalState: [state, setState], loadingState: [loading, setLoading], handleUpdateSolicitation, handleUpdateNotifications, handleUpdateUserData }}>
      {children}
    </RootContext.Provider>
  )
}
